import { useContext } from "react";
import StepperComponent from "../../../components/stepper/stepper";
import { BorderedBox } from "../../../components/bordered-box/bordered-box";
import OrganizationUpsertForm, {
  IAddEditProviderModel,
} from "../organization-upsert-form";
import {
  IOrganizationModel
} from "../organizations.model";
import pubSub, { EVENTS } from "../../../config/pubSub";
import { useService } from "../organizations-service";
import { OrganizationsContext } from "../organizations-context";

type IProps = {
  handleClose: () => void;
  handleDone: () => void;
  model: IAddEditProviderModel;
  handleModelChange: (updatedModel: any) => void;
  initialEmail: string;
  hasChanges: boolean;
  setHasChanges: (hasChanges: boolean) => void;
};

function getStepContent(
  model: IAddEditProviderModel,
  handleModelChange: (updatedModel: any) => void,
  initialEmail: string
) {
  return {
    0: (
      <BorderedBox>
        <OrganizationUpsertForm 
        model={model}
        handleModelChange={handleModelChange}
        initialEmail={initialEmail} />
      </BorderedBox>
    ),
  };
}

const EditComponent = (props: IProps) => {
  const { model, handleModelChange, initialEmail, hasChanges, setHasChanges } = props;
  const { orgService } = useService(); 
  const { selectedOrg, setSelectedOrg } = useContext(OrganizationsContext);

  const stepsContent = getStepContent(model, (updatedModel: any) => {
    handleModelChange(updatedModel);
    setHasChanges(updatedModel.hasChanges); 
  }, initialEmail);

  const handleCancel = () => {
    props.handleClose();
  };

  const handleDone = async () => {
    try {
      await orgService.updateOrg(
        {
          orgId: selectedOrg!,
          displayName: model[0].displayName,
          locale: model[0].locale!,
          adminEmail: model[0].email
        }
      );
        pubSub.publish(EVENTS.ORGANIZATIONS_LIST);
        setSelectedOrg(null);
        props.handleDone();
    } catch (error: any) {
      if (error.response) {
        switch (+error.response.status) {
          case 409:
            pubSub.publish(EVENTS.PP_ERROR_ORGANIZATION_DUP, error);
            break;
          default:
            pubSub.publish(EVENTS.ERROR, "common_error_msg");
        }
      } else {
        pubSub.publish(EVENTS.ERROR, "common_error_msg");
      }
    }
  };

  return (
    <>
      <StepperComponent
        isValid={model.isValid}
        stepsContent={stepsContent}
        handleCancel={handleCancel}
        handleDone={handleDone}
        isEdit={true}
        hasChanges={hasChanges}
      />
    </>
  );
};

export default EditComponent;
